import { render, staticRenderFns } from "./DataTableWithPagination.vue?vue&type=template&id=45bca81a"
import script from "./DataTableWithPagination.vue?vue&type=script&lang=js"
export * from "./DataTableWithPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports